import ProceduresPage from "../../shared-pages/manufacturer/ProceduresPage";

const AreaProceduresPage = ({ match }) => {
  const { id } = match.params;

  return <ProceduresPage manufacturerId={id} url={match.url} entityName="area" />;
};

export default AreaProceduresPage;
